module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-9059bc01.png";